// extracted by mini-css-extract-plugin
export default {"mCard":"Wy-z","image":"Xy-z","imageNoBackground":"Yy-z","fullWidth":"Zy-z"};